export const POST_MAX_ITEMS = 10;

// A post item is capped at five minutes
export const POST_MAX_VIDEO_DURATION_SECONDS = 300;

export const POST_TITLE_MAX_LENGTH = 40;

export const POST_CAPTION_MAX_LENGTH = 500;

// Matches the backend default; videos run for their own length.
export const POST_IMAGE_DURATION_SECONDS = 15;

export interface PostListItem {
  id: string;
  organizationId: string;
  title: string;
  description?: string;
  dateCreated: Date;
  dateUpdated: Date;
  publishStatus: number;
  folderId?: string;
  lessonId?: string;
  lessonContentId?: string;
  poster?: string;
  itemsCount: number;
  duration: number;
  published: boolean;
  publishedCourseId?: string;
  enrollNumber: number;
  type: number;
  isPublic: boolean;
  projectId?: string | null;
  projectName?: string | null;
}

export interface PostMediaItem {
  id: string;
  isVideo: boolean;
  title: string;
  url?: string;
  poster?: string;
}

export interface CreatePostPayload {
  title: string;
  description?: string;
  libraryMediaFileIds: string[];
  projectId?: string;
}
